import React from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import InputDatePicker from 'components/pages/customer-service/action-plans/create-action-plan/InputDatePicker';
import InputScanBin from 'components/pages/stock-location/stock-management/InputScanBin';
import PropTypes from 'prop-types';

function BookingInForm({
  formData,
  handleInputChange,
  handleDateChange,
  handleAssignBin,
  handleReceiveAll,
  isLoading,
  tableData,
  validated
}) {
  const handleBinOutput = (bin) => {
    handleInputChange('globalBinBarcode', bin?.binBarcode || '');
  };

  return (
    <Card className="mb-2 wpo-panel py-2 px-3 shadow-sm">
      <Card.Body className="p-0">
        <Row className="gy-2 gx-3">
          <Col lg={4} md={6}>
            <Form.Group>
              <Form.Label className="wpo-field-label text-700 mb-1 required">Delivery Note Ref</Form.Label>

              <Form.Control
                placeholder="Enter reference..."
                value={formData.deliveryNoteRef || ''}
                onChange={e => handleInputChange('deliveryNoteRef', e.target.value)}
                isInvalid={validated && !formData.deliveryNoteRef}
                style={{ height: '38px' }}
              />
              <Form.Control.Feedback type="invalid">
                Delivery Note Ref is required.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={4} md={6}>
            <Form.Group>
              <Form.Label className="wpo-field-label text-700 mb-1">Global Bin Barcode</Form.Label>

              <InputScanBin
                intialValue={formData.globalBinBarcode}
                outputData={handleBinOutput}
              />
            </Form.Group>
          </Col>
          <Col lg={4} md={12} className="d-flex align-items-end">
            <Button
              variant="outline-primary"
              className="w-100"
              onClick={handleAssignBin}
              disabled={isLoading || !tableData || tableData.length === 0 || !formData.globalBinBarcode}
              style={{ 
                height: '38px', 
                opacity: (isLoading || !tableData || tableData.length === 0 || !formData.globalBinBarcode) ? 0.5 : 1,
                pointerEvents: (isLoading || !tableData || tableData.length === 0 || !formData.globalBinBarcode) ? 'none' : 'auto',
                cursor: (isLoading || !tableData || tableData.length === 0 || !formData.globalBinBarcode) ? 'not-allowed' : 'pointer'
              }}
            >
              Assign Bin to all lines
            </Button>
          </Col>

          <Col lg={4} md={6}>
            <Form.Group>
              <Form.Label className="wpo-field-label text-700 mb-1">Date Received</Form.Label>

              <InputDatePicker
                column="dateReceived"
                selected={formData.dateReceived}
                handleChange={(col, val) => handleDateChange(val)}
                useUTC={true}
              />
            </Form.Group>
          </Col>
          <Col lg={4} md={6} className="d-flex align-items-end">
            <Button
              variant="outline-info"
              className="w-100"
              onClick={handleReceiveAll}
              disabled={isLoading || !tableData || tableData.length === 0}
              style={{ 
                height: '38px', 
                opacity: (isLoading || !tableData || tableData.length === 0) ? 0.5 : 1,
                pointerEvents: (isLoading || !tableData || tableData.length === 0) ? 'none' : 'auto',
                cursor: (isLoading || !tableData || tableData.length === 0) ? 'not-allowed' : 'pointer'
              }}
            >
              Receive all
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

BookingInForm.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  handleAssignBin: PropTypes.func.isRequired,
  handleReceiveAll: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  tableData: PropTypes.array,
  validated: PropTypes.bool
};

export default BookingInForm;
